// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export function importEcharts() {
  return import('echarts');
}
